var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"esp_page_header",style:({padding: _vm.padding})},[_c('div',{staticClass:"esp_header_left"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"esp_header_right",style:({width: _vm.btnWidth, paddingLeft: _vm.gutter})},[_vm._t("btn")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-813691dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/EspPageHeader.vue
// module id = null
// module chunks = 